module.exports = new __parcel__URL__("objective_like_button.496c8626.png").toString();